import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'user';
 
export default {
  getAccountDetail(token)
  {
      return Axios.get(RESOURCE_NAME + '/account/detail');
      // var accountDetail = RESOURCE_NAME + '/account/detail';
      //      return Axios.get(accountDetail, {
      //       headers: {
      //           Authorization: `Bearer ${token}`
      //       }
      //   })
  }
  /*getAll() {
    return Axios.get(RESOURCE_NAME);
  },
 
  get(id) {
    return Axios.get(`${RESOURCE_NAME}/${id}`);
  },
 
  create(data) {
    return Axios.post(RESOURCE_NAME, data);
  },
 
  update(id, data) {
    return Axios.put(`${RESOURCE_NAME}/${id}`, data);
  },
 
  delete(id) {
    return Axios.delete(`${RESOURCE_NAME}/${id}`);
  },

  getPermissions(token){
      var permissions = RESOURCE_NAME + '/permissions';
      return Axios.get(`${permissions}`);
  }*/
};
